import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* getLookbookOrder({ payload: { signal, id, orderId, onSuccess } }) {
  try {
    const { data } = yield call(fetch, { api: api.lookbooks.orders.get, pathParams: { id, orderId }, signal });

    onSuccess && onSuccess(data.result);
    yield put(actions.getLookbookOrderDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getLookbookOrderFailed,
      endpoint: api.lookbooks.orders.get.url
    });
  }
}

export const getLookbookOrderSaga = takeEvery(types.GET_LOOKBOOK_ORDER_REQUEST, getLookbookOrder);